import React from "react";
import getDates from "../../../../shared/services/date.service";

import styles from "./dataAnalyse.module.scss";
import { withDataAnalyseTimeRange } from "../../../../shared/containers/containerDataAnalyseTimeRange";
import DataAnalyseTimeRange from "./DataAnalyseTimeRange";
import DataAnalyseButtonWrapper from "./DataAnalyseButtonWrapper";

const isInvalidTime = (startDate, startTime, endDate, endTime) => {
  if (startDate === null || startTime === null || endDate === null || endTime === null) {
    return true;
  }

  let startHour = startTime.getHours();
  let startMin = startTime.getMinutes();
  let endHour = endTime.getHours();
  let endMin = endTime.getMinutes();

  let rangeStartDate = new Date(startDate);
  rangeStartDate.setHours(startHour);
  rangeStartDate.setMinutes(startMin);

  let rangeEndDate = new Date(endDate);
  rangeEndDate.setHours(endHour);
  rangeEndDate.setMinutes(endMin);

  let startDateUtc = getDates.getNullTimeDateUtcNumber(startDate);
  let endDateUtc = getDates.getNullTimeDateUtcNumber(endDate);

  return startDateUtc === endDateUtc && rangeStartDate > rangeEndDate;
};

const DataAnalyseTimeRangeForm = (props) => {
  const { onHandleChangeStore, rangeStartDate, rangeStartTime, rangeEndDate, rangeEndTime } = props;

  const startDate = getDates.getNullTimeDateUtcNumber(rangeStartDate);
  const endDate = getDates.getNullTimeDateUtcNumber(rangeEndDate);
  const currentDate = getDates.getNullTimeDateUtcNumber(new Date());

  let isTimeInvalid = isInvalidTime(rangeStartDate, rangeStartTime, rangeEndDate, rangeEndTime);

  const isButtonDisabled =
    !rangeStartDate ||
    !rangeStartTime ||
    !rangeEndDate ||
    !rangeEndTime ||
    isNaN(rangeStartDate) ||
    isNaN(rangeStartTime) ||
    isNaN(rangeEndDate) ||
    isNaN(rangeEndTime) ||
    startDate > currentDate ||
    startDate > endDate ||
    isTimeInvalid;

  return (
    <React.Fragment>
      <div className={styles.container_itemsTimeIntellegence}>
        <DataAnalyseTimeRange onHandleChangeStore={onHandleChangeStore} valueStore={props} />
        <div className={styles.container_itemsTimeButtom}>
          <DataAnalyseButtonWrapper disabled={isButtonDisabled} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default withDataAnalyseTimeRange(React.memo(DataAnalyseTimeRangeForm));
